import React from "react";
import "./Home.scss";
import { FaFacebook, FaLinkedin, FaGithub, FaEnvelope } from "react-icons/fa";

const Home = () => {
   return (
      <section id="home" className="home-section">
         <div className="home-container">
            <div className="home-content">
               <div className="home-left">
                  <div className="home-left-title">
                     <span className="home-left-title1">Full-Stack</span>
                     <span className="home-left-title2">Developer</span>
                  </div>
                  <div className="home-left-title3">
                     <span className="home-left-title-3">Web & Mobile</span>
                  </div>
                  <div className="home-left-middle">
                     <p>
                        As an IT, my primary responsibilities include managing both front-end and back-end and ensuring
                        that all tasks are completed efficiently and on time. In this role, I have to regularly
                        collaborate with cross-function teams, including project managers, to ensure that our projects
                        meet the required specifications. Key skills that are essential for this job include
                        problem-solving, communication, presentation, time management, as well as a strong understanding
                        of relevant field knowledge. Additionally, staying updated on the latest technologies and trends
                        in industry is crucial to my success in the role
                     </p>
                  </div>
                  <div className="home-left-card">
                     <div className="Java">Java</div>
                     <div className="JavaScript">JavaScript</div>
                     <div className="ReactJs">ReactJs</div>
                     <div className="NodeJs">NodeJs</div>
                     <div className="Kotlin">Kotlin</div>
                     <div className="Firebase">Firebase</div>
                     <div className="etc">....</div>
                  </div>

                  <div className="home-left-social">
                     <a
                        href="mailto:khanhbui.160905@gmail.com"
                        className="home-left-social-btn mail"
                        aria-label="Email"
                     >
                        <FaEnvelope />
                     </a>
                     <a
                        href="https://www.facebook.com/khanh.bui.916312"
                        className="home-left-social-btn facebook"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                     >
                        <FaFacebook />
                     </a>
                     <a
                        href="https://github.com/BuiQuocKhanh-VKU"
                        className="home-left-social-btn github"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="GitHub"
                     >
                        <FaGithub />
                     </a>
                     <a
                        href="https://www.linkedin.com/in/khanh-bui-quoc-6a8195305/"
                        className="home-left-social-btn linkedin"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                     >
                        <FaLinkedin />
                     </a>
                  </div>
               </div>

               <div className="home-right"></div>
            </div>
         </div>
      </section>
   );
};

export default Home;
